import React, { useEffect, useRef } from 'react';

const Pagination = ({ maxPages, currentPage, listId }) => {
  const paginationRef = useRef();

  useEffect(() => {
    function pageClicked(e) {
      const { detail: { current } } = e;

      const pageEle = document.getElementById('product-listing-' + listId + '-page-' + current);
      if (pageEle) {
        pageEle.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    if (paginationRef && paginationRef.current) {
      paginationRef.current.addEventListener('current-clicked', pageClicked, false);
    }
    return function cleanup() {
      if (paginationRef.current) {
        paginationRef.current.removeEventListener('current-clicked', pageClicked, false);
      }
    };
  }, []);

  return (
    <ft-pagination ref={paginationRef} count={maxPages}
                   current={currentPage}></ft-pagination>
  );
};

export default Pagination;
